import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificacionesTable } from "./NotificacionesTable";
import { NewBtn, PageHeaderUi, ReLoadBtn } from "../ui";
import {
  notificacionClearActive,
  notificacionesStartLoad,
} from "../../actions/notificacion";
import { NotificacionModal } from "./modal/NotificacionModal";

export const NotificacionesList = () => {
  const dispatch = useDispatch();
  const [visibleModal, setVisibleModal] = useState(false);
  const { notificaciones, loading } = useSelector(
    (state) => state.notificacion,
  );
  const handleOpenModal = () => setVisibleModal(true);
  const handleCloseModal = () => {
    dispatch(notificacionClearActive());
    setVisibleModal(false);
  };
  const handleReLoad = () => {
    dispatch(notificacionesStartLoad());
  };
  useEffect(() => {
    dispatch(notificacionesStartLoad());
  }, []);
  return (
    <PageHeaderUi
      title="Notificaciones"
      subTitle="Listado"
      extra={[
        <ReLoadBtn key="reload" onClick={handleReLoad} />,
        <NewBtn key="nuevo" onClick={handleOpenModal} />,
      ]}
    >
      <NotificacionesTable
        data={notificaciones}
        loading={loading}
        onOpenModal={handleOpenModal}
      />
      <NotificacionModal openModal={visibleModal} onClose={handleCloseModal} />
    </PageHeaderUi>
  );
};

export default NotificacionesList;
